import { Trigger } from '@radix-ui/react-dialog'

export const DrawerTrigger = Trigger
